import React, { createContext, useContext } from 'react'

/**
 * Optional auth token provider. When present, useApi (and other consumers) use this
 * instead of Clerk for request tokens. Used by Storybook and gated E2E (`getE2eAuthToken`)
 * where real auth sessions are not available.
 */
export interface AuthTokenOverride {
    getToken: () => Promise<string | null>
}

const AuthTokenContext = createContext<AuthTokenOverride | null>(null)

export function useAuthTokenOverride(): AuthTokenOverride | null {
    return useContext(AuthTokenContext)
}

interface AuthTokenProviderProps {
    children: React.ReactNode
    getToken: () => Promise<string | null>
}

export function AuthTokenProvider({ children, getToken }: AuthTokenProviderProps) {
    const value = React.useMemo<AuthTokenOverride>(() => ({ getToken }), [getToken])
    return <AuthTokenContext.Provider value={value}>{children}</AuthTokenContext.Provider>
}
